// Build-time feature flags.
//
// React env vars must be prefixed with REACT_APP_ and are baked in at build
// time (npm start / npm run build reads .env, .env.development, .env.production).
// Toggling a flag requires restarting `npm start` (or rebuilding for prod).
//
//   REACT_APP_SHOW_MTC_MENUS=true   → exposes the AML operational menus
//                                     and routes built for the MTC25-26-O tender.
//                                     Default (unset / anything else) hides them.

const truthy = (v) => v === 'true' || v === '1' || v === true;

export const SHOW_MTC_MENUS = truthy(process.env.REACT_APP_SHOW_MTC_MENUS);
